package com.eladfinish.bible.contest.ui.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.eladfinish.bible.contest.platform.shake.ShakeController
import kotlinx.coroutines.awaitCancellation

/**
 * Starts [shakeController] when [isShakeEnabled] is true and calls [onShaken] on each shake.
 * Automatically stops the controller when the composable leaves the composition or
 * [isShakeEnabled] becomes false.
 */
@Composable
fun ShakeBindings(
    isShakeEnabled: Boolean,
    shakeController: ShakeController,
    onShaken: () -> Unit,
) {
    LaunchedEffect(isShakeEnabled) {
        if (!isShakeEnabled) return@LaunchedEffect

        shakeController.start { onShaken() }

        try {
            awaitCancellation()
        } finally {
            shakeController.stop()
        }
    }
}
